import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Camera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime, share, tap } from 'rxjs/operators';
import { NaviFreshMartService } from '../services/navi-fresh-mart.service';
import { Stall } from '../classes/stall';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-scanner-animate',
  templateUrl: './scanner-animate.component.html',
  styleUrls: ['./scanner-animate.component.scss']
})
export class ScannerAnimateComponent implements OnInit {
  qrcodeImg = "../../../assets/images/qr-code.svg";
  showScan: boolean = false;

  labelText: string = 'Scan here';
  scrollingTimer: number | null = null;
  modalReference;
  isContainerVisible: boolean = false;
  linePosition: number;
  interval: any;
  machinesList: Stall[] = [];
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  hasDevices: boolean;
  hasPermission: boolean;
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;
  @ViewChild('excludeDiv', { static: true }) excludeDiv: ElementRef;
  isMobileOrDesktop: boolean = false;
  accountId = ""
  constructor(private renderer: Renderer2,
    private el: ElementRef,
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private router: Router,
    private naviService: NaviFreshMartService,
    public dataService: DataService) { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user'));

    this.accountId = user.accountId;
    this.naviService.getMachines(1001, this.accountId).subscribe((data) => {
      this.machinesList = data;
      this.machinesList = this.machinesList.filter(item => (item.type == "Genie" && item.status == "Active"));
    });
  }
  @HostListener('window:scroll', [])
  onScroll(): void {
    // Clear any existing scrolling timer
    if (this.scrollingTimer !== null) {
      window.cancelAnimationFrame(this.scrollingTimer);
      this.showScan = false;
      const iconDiv = this.el.nativeElement.querySelector('.icon-div');
      if (iconDiv) {
        this.renderer.removeClass(iconDiv, 'fadeInOut');
        setTimeout(() => {
          const scanText = this.el.nativeElement.querySelector('.scan-text');
          if (scanText) {
            this.renderer.removeClass(scanText, 'textAnimation');
            this.renderer.removeClass(iconDiv, 'width-180');
          }
        }, 1000);
      }
    }



    // Set a new scrolling timer using requestAnimationFrame
    this.scrollingTimer = window.requestAnimationFrame(() => {
      // Logic to run after scrolling stops
      this.HideOrShowScan(true);
      setTimeout(() => {
        this.HideOrShowScan(false);
      }, 10000);

      // Reset scrolling timer to null
      this.scrollingTimer = null;
    });
  }

  // @HostListener('window:click', ['$event'])
  // onClick(event: Event): void {
  //     console.log(event.target);
  //   // Hide the icon when the user clicks anywhere on the page
  //   const clickedOnExcludeDiv = document.getElementById("excludeDiv");

  //   // Hide the icon when the user clicks anywhere on the page, excluding the specified div
  //   if (!clickedOnExcludeDiv) {
  //     this.HideOrShowScan(false);
  //   }
  // }

  @HostListener('window:touchstart', ['$event'])
  onTouchStart(event): void {
    // Hide the icon when the user touches the screen
    const id = event.target.id;
    if (id) {
      if (!id.contains("excludeDiv")) this.HideOrShowScan(false);
    }
    else {
      this.HideOrShowScan(false);
    }
  }
  HideOrShowScan(isShow: boolean) {
    this.showScan = isShow;
    const iconDiv = this.el.nativeElement.querySelector('.icon-div');
    if (iconDiv) {
      if (this.showScan) {
        this.renderer.addClass(iconDiv, 'fadeInOut');
        setTimeout(() => {
          const scanText = this.el.nativeElement.querySelector('.scan-text');
          if (scanText) {
            this.renderer.addClass(scanText, 'textAnimation');
            this.renderer.addClass(iconDiv, 'width-180');
          }
        }, 1000);
      }
      else {
        this.renderer.removeClass(iconDiv, 'fadeInOut');
        setTimeout(() => {
          const scanText = this.el.nativeElement.querySelector('.scan-text');
          if (scanText) {
            this.renderer.removeClass(scanText, 'textAnimation');
            this.renderer.removeClass(iconDiv, 'width-180');
          }
        }, 1000);
      }

    }
  }
  async OnScanPress(modal, event) {

    if (Capacitor.getPlatform() != "web") {
      this.isMobileOrDesktop = true;
      const result = await Camera.requestPermissions();
      if (result.camera === 'granted') {
        console.log('Camera permissions granted.');
        this.modalReference = this.modalService.open(modal);
        this.animateLine();
        // Proceed with camera operations
      } else {
        console.log('Camera permissions denied.');
        return
        // Handle the denied permissions
      }
    }
    else {
      this.modalReference = this.modalService.open(modal);
      if (window.innerWidth <= 700) this.isMobileOrDesktop = true;
      else this.isMobileOrDesktop = false;
      this.animateLine();
    }
  }
  animateLine() {
    this.isContainerVisible = true;
    this.interval = setInterval(() => {
      this.linePosition += 1;

      if (this.linePosition >= 100) {
        this.linePosition = 0;
      }
    }, 10); // Adjust the interval as needed
  }
  onScanSuccess(qrresult: string) {
    this.modalReference.close();
    let lastSegment = "";
    if (qrresult.includes("GEN_")) {
      const parts = qrresult.split("#");
      if (parts.length > 1) {
        console.log(parts[1]);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([`${parts[1]}`]);
      }
    }
    if (qrresult.includes("SLT_")) {
      const parts = qrresult.split("#");
      if (parts.length > 1) {
        console.log(parts[1]);
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        }
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([`${parts[1]}`]);
      }
    }
    if (!qrresult.includes("GEN_") && !qrresult.includes("SLT_")) {
      const machIdOrDisplayId = qrresult;
      const machineObj = this.machinesList.find(obj => obj.stallid == parseInt(machIdOrDisplayId) || obj.vmsMachId == machIdOrDisplayId);
      if (machineObj) {
        this.dataService.setMachineId(machineObj.stallid);
        localStorage.setItem("genieName", machineObj.name);
        localStorage.setItem('genieId', machineObj.stallid + "");
        this.dataService.UpdateGenieName(machineObj.name);
        this.dataService.setGenieStatus(machineObj.cloudStatus);

        // temporary
        //  this.dataService.setIsSearchDisable(true);

      }
      else {
        this.snackBar.open("Wrong Machine QR Code", 'X', {
          panelClass: 'toast-message',
          duration: 5000
        })
      }
    }











  }
  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }
  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }
  onClose() {
    this.modalReference.close();
    if (this.interval) clearInterval(this.interval);
  }
}
